/** @module csi/widget/_svg/Image */
define([
	"dijit/form/ToggleButton",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(ToggleButton,_Plugin,PluginFactory,util) {

	return PluginFactory.declare([ToggleButton, _Plugin], {
		"class": "csi-button-toggle",
		materialIcon: "add_a_photo",
		pluginName: "image",
		title: "CanvasImage",

		/**
		 * Open image browser to select images to add to canvas
		 */
		onClick: function() {
			var actionWidget = this;
			var editor = this.editor;

			editor.setNoDrawMode();

			this.getView().insertImage({
				onEnd: function() {
					// ensure that after adding an image or clicking cancel, the add image
					// button is not depressed, and the select button is depressed
					actionWidget.set("checked", false);
					editor.canvasApp.canvasApi().setCanvasMode(util.canvasModes.SELECT);
				}
			});
		}
	});
});
